/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Ph_NameInputs */

const tr_mascot_chat_ph_name = /** @type {(inputs: Mascot_Chat_Ph_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad Soyad`)
};

const en_mascot_chat_ph_name = /** @type {(inputs: Mascot_Chat_Ph_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name`)
};

const de_mascot_chat_ph_name = /** @type {(inputs: Mascot_Chat_Ph_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor- und Nachname`)
};

const ru_mascot_chat_ph_name = /** @type {(inputs: Mascot_Chat_Ph_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя и фамилия`)
};

/**
* | output |
* | --- |
* | "Full Name" |
*
* @param {Mascot_Chat_Ph_NameInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_ph_name = /** @type {((inputs?: Mascot_Chat_Ph_NameInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Ph_NameInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_ph_name(inputs)
	if (locale === "de") return de_mascot_chat_ph_name(inputs)
	if (locale === "ru") return ru_mascot_chat_ph_name(inputs)
	return tr_mascot_chat_ph_name(inputs)
});